(function (factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js', './kotlinx-coroutines-core.js', './kotlinx-io-kotlinx-io-core.js', './kotlinx-atomicfu.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'), require('./kotlinx-coroutines-core.js'), require('./kotlinx-io-kotlinx-io-core.js'), require('./kotlinx-atomicfu.js'));
  else {
    if (typeof globalThis['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-io'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'ktor-ktor-io'.");
    }
    if (typeof globalThis['kotlinx-coroutines-core'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-io'. Its dependency 'kotlinx-coroutines-core' was not found. Please, check whether 'kotlinx-coroutines-core' is loaded prior to 'ktor-ktor-io'.");
    }
    if (typeof globalThis['kotlinx-io-kotlinx-io-core'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-io'. Its dependency 'kotlinx-io-kotlinx-io-core' was not found. Please, check whether 'kotlinx-io-kotlinx-io-core' is loaded prior to 'ktor-ktor-io'.");
    }
    if (typeof globalThis['kotlinx-atomicfu'] === 'undefined') {
      throw new Error("Error loading module 'ktor-ktor-io'. Its dependency 'kotlinx-atomicfu' was not found. Please, check whether 'kotlinx-atomicfu' is loaded prior to 'ktor-ktor-io'.");
    }
    globalThis['ktor-ktor-io'] = factory(typeof globalThis['ktor-ktor-io'] === 'undefined' ? {} : globalThis['ktor-ktor-io'], globalThis['kotlin-kotlin-stdlib'], globalThis['kotlinx-coroutines-core'], globalThis['kotlinx-io-kotlinx-io-core'], globalThis['kotlinx-atomicfu']);
  }
}(function (_, kotlin_kotlin, kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core, kotlin_org_jetbrains_kotlinx_kotlinx_io_core, kotlin_org_jetbrains_kotlinx_atomicfu) {
  'use strict';
  //region block: imports
  var Companion_instance = kotlin_kotlin.$_$.z4;
  var Unit_instance = kotlin_kotlin.$_$.e5;
  var _Result___init__impl__xyqfz8 = kotlin_kotlin.$_$.x2;
  var protoOf = kotlin_kotlin.$_$.tc;
  var initMetadataForCompanion = kotlin_kotlin.$_$.rb;
  var THROW_CCE = kotlin_kotlin.$_$.wg;
  var initMetadataForObject = kotlin_kotlin.$_$.wb;
  var toString = kotlin_kotlin.$_$.ci;
  var hashCode = kotlin_kotlin.$_$.pb;
  var equals = kotlin_kotlin.$_$.hb;
  var initMetadataForClass = kotlin_kotlin.$_$.qb;
  var createFailure = kotlin_kotlin.$_$.oh;
  var Result = kotlin_kotlin.$_$.ug;
  var initMetadataForInterface = kotlin_kotlin.$_$.ub;
  var VOID = kotlin_kotlin.$_$.i;
  var isInterface = kotlin_kotlin.$_$.gc;
  var CoroutineImpl = kotlin_kotlin.$_$.qa;
  var numberToLong = kotlin_kotlin.$_$.rc;
  var toLong = kotlin_kotlin.$_$.vc;
  var intercepted = kotlin_kotlin.$_$.da;
  var CancellableContinuationImpl = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.r;
  var noWhenBranchMatchedException = kotlin_kotlin.$_$.wh;
  var returnIfSuspended = kotlin_kotlin.$_$.m;
  var get_COROUTINE_SUSPENDED = kotlin_kotlin.$_$.aa;
  var Long = kotlin_kotlin.$_$.rg;
  var initMetadataForCoroutine = kotlin_kotlin.$_$.sb;
  var Buffer = kotlin_org_jetbrains_kotlinx_kotlinx_io_core.$_$.e;
  var atomic$ref$1 = kotlin_org_jetbrains_kotlinx_atomicfu.$_$.d;
  var IOException_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_io_core.$_$.c;
  var IllegalStateException = kotlin_kotlin.$_$.qg;
  var IllegalStateException_init_$Init$ = kotlin_kotlin.$_$.y1;
  var captureStack = kotlin_kotlin.$_$.za;
  var EOFException_init_$Create$ = kotlin_org_jetbrains_kotlinx_kotlinx_io_core.$_$.a;
  var EmptyCoroutineContext_getInstance = kotlin_kotlin.$_$.m4;
  var CoroutineScope = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.z;
  var launch = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.l1;
  var startCoroutineCancellable = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.q;
  var Continuation = kotlin_kotlin.$_$.ka;
  var initMetadataForFunctionReference = kotlin_kotlin.$_$.tb;
  var get_job = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.k1;
  var Job = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.a1;
  var cancel = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.g1;
  var initMetadataForLambda = kotlin_kotlin.$_$.vb;
  var CopyableThrowable = kotlin_org_jetbrains_kotlinx_kotlinx_coroutines_core.$_$.v;
  var IOException = kotlin_org_jetbrains_kotlinx_kotlinx_io_core.$_$.f;
  var IOException_init_$Create$_0 = kotlin_org_jetbrains_kotlinx_kotlinx_io_core.$_$.d;
  var CancellationException_init_$Create$ = kotlin_kotlin.$_$.f1;
  var CancellationException = kotlin_kotlin.$_$.z9;
  var readString = kotlin_org_jetbrains_kotlinx_kotlinx_io_core.$_$.j;
  var StringBuilder_init_$Create$ = kotlin_kotlin.$_$.i1;
  var toString_0 = kotlin_kotlin.$_$.xc;
  var IllegalStateException_init_$Create$ = kotlin_kotlin.$_$.z1;
  var charSequenceLength = kotlin_kotlin.$_$.db;
  var readByteArray = kotlin_org_jetbrains_kotlinx_kotlinx_io_core.$_$.h;
  var readString_0 = kotlin_org_jetbrains_kotlinx_kotlinx_io_core.$_$.k;
  var encodeToByteArray = kotlin_kotlin.$_$.ce;
  var writeString = kotlin_org_jetbrains_kotlinx_kotlinx_io_core.$_$.l;
  var _Char___init__impl__6a9atx = kotlin_kotlin.$_$.p2;
  var replace = kotlin_kotlin.$_$.ze;
  var IllegalArgumentException_init_$Create$ = kotlin_kotlin.$_$.v1;
  var getStringHashCode = kotlin_kotlin.$_$.ob;
  var IOException_init_$Init$ = kotlin_org_jetbrains_kotlinx_kotlinx_io_core.$_$.b;
  var readByteArray_0 = kotlin_org_jetbrains_kotlinx_kotlinx_io_core.$_$.i;
  var charSequenceSubSequence = kotlin_kotlin.$_$.eb;
  var isCharSequence = kotlin_kotlin.$_$.cc;
  var trim = kotlin_kotlin.$_$.dg;
  var toByte = kotlin_kotlin.$_$.uc;
  var decodeToString = kotlin_kotlin.$_$.yd;
  var setOf = kotlin_kotlin.$_$.a9;
  var charSequenceGet = kotlin_kotlin.$_$.cb;
  var Char__toInt_impl_vasixd = kotlin_kotlin.$_$.v2;
  var fillArrayVal = kotlin_kotlin.$_$.jb;
  //endregion
  //region block: pre-declaration
  initMetadataForCompanion(Companion);
  initMetadataForObject(Empty, 'Empty');
  initMetadataForClass(Closed, 'Closed');
  function resume() {
    return this.a4x().r9(Companion_getInstance().y4w_1);
  }
  function resume_0(throwable) {
    var tmp = this.a4x();
    var tmp_0;
    if (throwable == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'io.ktor.utils.io.Task.resume.<anonymous>' call
      // Inline function 'kotlin.Companion.failure' call
      var tmp$ret$2 = _Result___init__impl__xyqfz8(createFailure(throwable));
      tmp_0 = new Result(tmp$ret$2);
    }
    var tmp1_elvis_lhs = tmp_0;
    return tmp.r9(tmp1_elvis_lhs == null ? Companion_getInstance().y4w_1 : tmp1_elvis_lhs.dl_1);
  }
  initMetadataForInterface(Task, 'Task');
  initMetadataForClass(Read, 'Read', VOID, VOID, [Task]);
  initMetadataForClass(Write, 'Write', VOID, VOID, [Task]);
  initMetadataForCoroutine($awaitContentCOROUTINE$0, CoroutineImpl);
  initMetadataForCoroutine($flushCOROUTINE$1, CoroutineImpl);
  initMetadataForCoroutine($flushAndCloseCOROUTINE$2, CoroutineImpl);
  function awaitContent$default(min, $completion, $super) {
    min = min === VOID ? 1 : min;
    return $super === VOID ? this.e4z(min, $completion) : $super.e4z.call(this, min, $completion);
  }
  initMetadataForInterface(ByteReadChannel_1, 'ByteReadChannel', VOID, VOID, VOID, [1]);
  initMetadataForClass(ByteChannel, 'ByteChannel', ByteChannel, VOID, [ByteReadChannel_1], [1, 0]);
  initMetadataForClass(ConcurrentIOException, 'ConcurrentIOException', VOID, IllegalStateException);
  initMetadataForClass(ByteReadChannel$Companion$Empty$1, VOID, VOID, VOID, [ByteReadChannel_1], [1]);
  initMetadataForCompanion(Companion_0);
  initMetadataForCoroutine($readRemainingCOROUTINE$3, CoroutineImpl);
  initMetadataForCoroutine($readPacketCOROUTINE$4, CoroutineImpl);
  initMetadataForCoroutine($readAvailableCOROUTINE$7, CoroutineImpl);
  initMetadataForCoroutine($toByteArrayCOROUTINE$9, CoroutineImpl);
  initMetadataForCoroutine($copyToCOROUTINE$10, CoroutineImpl);
  initMetadataForCoroutine($readBufferCOROUTINE$12, CoroutineImpl);
  initMetadataForCoroutine($flushIfNeededCOROUTINE$13, CoroutineImpl);
  initMetadataForClass(WriterJob, 'WriterJob');
  initMetadataForClass(WriterScope, 'WriterScope', VOID, VOID, [CoroutineScope]);
  initMetadataForClass(NO_CALLBACK$1, VOID, VOID, VOID, [Continuation]);
  initMetadataForFunctionReference(ByteWriteChannel$flushAndClose$ref, VOID, VOID, [0]);
  initMetadataForLambda(writer$slambda, CoroutineImpl, VOID, [1]);
  initMetadataForClass(CloseToken, 'CloseToken');
  initMetadataForClass(SourceByteReadChannel, 'SourceByteReadChannel', VOID, VOID, [ByteReadChannel_1], [1]);
  initMetadataForClass(DefaultPool, 'DefaultPool');
  initMetadataForClass(ByteArrayPool$1, VOID, VOID, DefaultPool);
  initMetadataForCompanion(Companion_1);
  initMetadataForClass(Charset, 'Charset');
  initMetadataForObject(Charsets, 'Charsets');
  initMetadataForClass(MalformedInputException, 'MalformedInputException', VOID, IOException);
  initMetadataForClass(CharsetDecoder, 'CharsetDecoder');
  initMetadataForClass(CharsetEncoder, 'CharsetEncoder');
  initMetadataForClass(CharsetImpl, 'CharsetImpl', VOID, Charset);
  initMetadataForClass(CharsetEncoderImpl, 'CharsetEncoderImpl', VOID, CharsetEncoder);
  initMetadataForClass(CharsetDecoderImpl, 'CharsetDecoderImpl', VOID, CharsetDecoder);
  initMetadataForClass(toKtor$1);
  initMetadataForClass(TextDecoderFallback, 'TextDecoderFallback');
  //endregion
  function Companion() {
    Companion_instance_0 = this;
    this.x4w_1 = new Closed(null);
    var tmp = this;
    // Inline function 'kotlin.Companion.success' call
    tmp.y4w_1 = _Result___init__impl__xyqfz8(Unit_instance);
  }
  var Companion_instance_0;
  function Companion_getInstance() {
    if (Companion_instance_0 == null)
      new Companion();
    return Companion_instance_0;
  }
  function Empty() {
  }
  protoOf(Empty).toString = function () {
    return 'Empty';
  };
  protoOf(Empty).hashCode = function () {
    return -231472095;
  };
  protoOf(Empty).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Empty))
      return false;
    other instanceof Empty || THROW_CCE();
    return true;
  };
  var Empty_instance;
  function Empty_getInstance() {
    return Empty_instance;
  }
  function Closed(cause) {
    this.z4w_1 = cause;
  }
  protoOf(Closed).toString = function () {
    return 'Closed(cause=' + toString(this.z4w_1) + ')';
  };
  protoOf(Closed).hashCode = function () {
    return this.z4w_1 == null ? 0 : hashCode(this.z4w_1);
  };
  protoOf(Closed).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof Closed))
      return false;
    var tmp0_other_with_cast = other instanceof Closed ? other : THROW_CCE();
    if (!equals(this.z4w_1, tmp0_other_with_cast.z4w_1))
      return false;
    return true;
  };
  function Task() {
  }
  function Read(continuation) {
    this.e4x_1 = continuation;
  }
  protoOf(Read).a4x = function () {
    return this.e4x_1;
  };
  protoOf(Read).b4x = function () {
    return 'read';
  };
  function Write(continuation) {
    this.f4x_1 = continuation;
  }
  protoOf(Write).a4x = function () {
    return this.f4x_1;
  };
  protoOf(Write).b4x = function () {
    return 'write';
  };
  function moveFlushToReadBuffer($this) {
    // Inline function 'io.ktor.utils.io.locks.synchronized' call
    $this.j4x_1;
    $this.h4x_1.b4v($this.l4x_1);
    $this.i4x_1 = 0;
    // Inline function 'io.ktor.utils.io.ByteChannel.resumeSlot' call
    var current = $this.k4x_1.kotlinx$atomicfu$value;
    var tmp;
    if (current instanceof Write) {
      tmp = $this.k4x_1.atomicfu$compareAndSet(current, Empty_instance);
    } else {
      tmp = false;
    }
    if (tmp) {
      current.c4x();
    }
  }
  function closeSlot($this, cause) {
    var closeContinuation = !(cause == null) ? new Closed(cause) : Companion_getInstance().x4w_1;
    var continuation = $this.k4x_1.atomicfu$getAndSet(closeContinuation);
    if (!isInterface(continuation, Task))
      return Unit_instance;
    continuation.d4x(cause);
  }
  function $awaitContentCOROUTINE$0(_this__u8e3s4, min, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.w4x_1 = _this__u8e3s4;
    this.x4x_1 = min;
  }
  protoOf($awaitContentCOROUTINE$0).o9 = function () {
    var suspendResult = this.i9_1;
    $sm: do
      try {
        var tmp = this.g9_1;
        switch (tmp) {
          case 0:
            this.h9_1 = 4;
            rethrowCloseCauseIfNeeded_1(this.w4x_1);
            if (numberToLong(this.w4x_1.i4x_1).u2(this.w4x_1.l4x_1.j()).e1(toLong(this.x4x_1)) >= 0)
              return true;
            var tmp_0 = this;
            tmp_0.y4x_1 = this.w4x_1;
            this.g9_1 = 1;
            continue $sm;
          case 1:
            if (!(numberToLong(this.w4x_1.i4x_1).u2(this.w4x_1.l4x_1.j()).e1(toLong(this.x4x_1)) < 0 && this.w4x_1.n4x_1.kotlinx$atomicfu$value == null)) {
              this.g9_1 = 3;
              continue $sm;
            }

            this.g9_1 = 2;
            var cancellable = new CancellableContinuationImpl(intercepted(this), 1);
            cancellable.e4a();
            l$ret$1: do {
              var this_0 = this.y4x_1;
              var slot = new Read(cancellable);
              var previous = this_0.k4x_1.kotlinx$atomicfu$value;
              if (!(previous instanceof Closed)) {
                if (!this_0.k4x_1.atomicfu$compareAndSet(previous, slot)) {
                  slot.c4x();
                  break l$ret$1;
                }
              }
              if (previous instanceof Read) {
                previous.d4x(new ConcurrentIOException(slot.b4x()));
              } else {
                if (isInterface(previous, Task)) {
                  previous.c4x();
                } else {
                  if (previous instanceof Closed) {
                    slot.d4x(previous.z4w_1);
                    break l$ret$1;
                  } else {
                    if (!equals(previous, Empty_instance)) {
                      noWhenBranchMatchedException();
                    }
                  }
                }
              }
              if (!(numberToLong(this.w4x_1.i4x_1).u2(this.w4x_1.l4x_1.j()).e1(toLong(this.x4x_1)) < 0 && this.w4x_1.n4x_1.kotlinx$atomicfu$value == null)) {
                var current = this_0.k4x_1.kotlinx$atomicfu$value;
                var tmp_1;
                if (current instanceof Read) {
                  tmp_1 = this_0.k4x_1.atomicfu$compareAndSet(current, Empty_instance);
                } else {
                  tmp_1 = false;
                }
                if (tmp_1) {
                  current.c4x();
                }
              }
            }
             while (false);
            suspendResult = returnIfSuspended(cancellable.k47(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.g9_1 = 1;
            continue $sm;
          case 3:
            if (this.w4x_1.l4x_1.j().e1(new Long(1048576, 0)) < 0) {
              moveFlushToReadBuffer(this.w4x_1);
            }

            return this.w4x_1.l4x_1.j().e1(toLong(this.x4x_1)) >= 0;
          case 4:
            throw this.j9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.h9_1 === 4) {
          throw e;
        } else {
          this.g9_1 = this.h9_1;
          this.j9_1 = e;
        }
      }
     while (true);
  };
  function $flushCOROUTINE$1(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.h4y_1 = _this__u8e3s4;
  }
  protoOf($flushCOROUTINE$1).o9 = function () {
    var suspendResult = this.i9_1;
    $sm: do
      try {
        var tmp = this.g9_1;
        switch (tmp) {
          case 0:
            this.h9_1 = 4;
            rethrowCloseCauseIfNeeded_1(this.h4y_1);
            this.h4y_1.j4y();
            if (this.h4y_1.i4x_1 < 1048576)
              return Unit_instance;
            var tmp_0 = this;
            tmp_0.i4y_1 = this.h4y_1;
            this.g9_1 = 1;
            continue $sm;
          case 1:
            if (!(this.h4y_1.i4x_1 >= 1048576 && this.h4y_1.n4x_1.kotlinx$atomicfu$value == null)) {
              this.g9_1 = 3;
              continue $sm;
            }

            this.g9_1 = 2;
            var cancellable = new CancellableContinuationImpl(intercepted(this), 1);
            cancellable.e4a();
            l$ret$1: do {
              var this_0 = this.i4y_1;
              var slot = new Write(cancellable);
              var previous = this_0.k4x_1.kotlinx$atomicfu$value;
              if (!(previous instanceof Closed)) {
                if (!this_0.k4x_1.atomicfu$compareAndSet(previous, slot)) {
                  slot.c4x();
                  break l$ret$1;
                }
              }
              if (previous instanceof Write) {
                previous.d4x(new ConcurrentIOException(slot.b4x()));
              } else {
                if (isInterface(previous, Task)) {
                  previous.c4x();
                } else {
                  if (previous instanceof Closed) {
                    slot.d4x(previous.z4w_1);
                    break l$ret$1;
                  } else {
                    if (!equals(previous, Empty_instance)) {
                      noWhenBranchMatchedException();
                    }
                  }
                }
              }
              if (!(this.h4y_1.i4x_1 >= 1048576 && this.h4y_1.n4x_1.kotlinx$atomicfu$value == null)) {
                var current = this_0.k4x_1.kotlinx$atomicfu$value;
                var tmp_1;
                if (current instanceof Write) {
                  tmp_1 = this_0.k4x_1.atomicfu$compareAndSet(current, Empty_instance);
                } else {
                  tmp_1 = false;
                }
                if (tmp_1) {
                  current.c4x();
                }
              }
            }
             while (false);
            suspendResult = returnIfSuspended(cancellable.k47(), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.g9_1 = 1;
            continue $sm;
          case 3:
            return Unit_instance;
          case 4:
            throw this.j9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.h9_1 === 4) {
          throw e;
        } else {
          this.g9_1 = this.h9_1;
          this.j9_1 = e;
        }
      }
     while (true);
  };
  function $flushAndCloseCOROUTINE$2(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.s4y_1 = _this__u8e3s4;
  }
  protoOf($flushAndCloseCOROUTINE$2).o9 = function () {
    var suspendResult = this.i9_1;
    $sm: do
      try {
        var tmp = this.g9_1;
        switch (tmp) {
          case 0:
            this.h9_1 = 4;
            var tmp_0 = this;
            tmp_0.t4y_1 = this.s4y_1;
            this.h9_1 = 2;
            var tmp_1 = this;
            tmp_1.v4y_1 = Companion_instance;
            var tmp_2 = this;
            tmp_2.w4y_1 = this.t4y_1;
            this.g9_1 = 1;
            suspendResult = this.w4y_1.x4y(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            this.u4y_1 = _Result___init__impl__xyqfz8(Unit_instance);
            this.h9_1 = 4;
            this.g9_1 = 3;
            continue $sm;
          case 2:
            this.h9_1 = 4;
            var tmp_3 = this.j9_1;
            if (tmp_3 instanceof Error) {
              var e = this.j9_1;
              var tmp_4 = this;
              tmp_4.u4y_1 = _Result___init__impl__xyqfz8(createFailure(e));
              this.g9_1 = 3;
              continue $sm;
            } else {
              throw this.j9_1;
            }

          case 3:
            this.h9_1 = 4;
            if (!this.s4y_1.n4x_1.atomicfu$compareAndSet(null, get_CLOSED()))
              return Unit_instance;
            closeSlot(this.s4y_1, null);
            return Unit_instance;
          case 4:
            throw this.j9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.h9_1 === 4) {
          throw e_0;
        } else {
          this.g9_1 = this.h9_1;
          this.j9_1 = e_0;
        }
      }
     while (true);
  };
  function ByteChannel(autoFlush) {
    autoFlush = autoFlush === VOID ? false : autoFlush;
    this.g4x_1 = autoFlush;
    this.h4x_1 = new Buffer();
    this.i4x_1 = 0;
    this.j4x_1 = new Object();
    this.k4x_1 = atomic$ref$1(Empty_instance);
    this.l4x_1 = new Buffer();
    this.m4x_1 = new Buffer();
    this.n4x_1 = atomic$ref$1(null);
  }
  protoOf(ByteChannel).y4y = function () {
    var tmp0_safe_receiver = this.z4y();
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      throw tmp0_safe_receiver;
    }
    if (this.l4x_1.z4t()) {
      moveFlushToReadBuffer(this);
    }
    return this.l4x_1;
  };
  protoOf(ByteChannel).a4z = function () {
    var tmp0_safe_receiver = this.z4y();
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      throw tmp0_safe_receiver;
    }
    if (this.b4z()) {
      throw IOException_init_$Create$('Channel is closed for write');
    }
    return this.m4x_1;
  };
  protoOf(ByteChannel).z4y = function () {
    var tmp0_safe_receiver = this.n4x_1.kotlinx$atomicfu$value;
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ba();
  };
  protoOf(ByteChannel).b4z = function () {
    return !(this.n4x_1.kotlinx$atomicfu$value == null);
  };
  protoOf(ByteChannel).d4z = function () {
    return !(this.z4y() == null) || (this.b4z() && this.i4x_1 === 0 && this.l4x_1.z4t());
  };
  protoOf(ByteChannel).e4z = function (min, $completion) {
    var tmp = new $awaitContentCOROUTINE$0(this, min, $completion);
    tmp.i9_1 = Unit_instance;
    tmp.j9_1 = null;
    return tmp.o9();
  };
  protoOf(ByteChannel).x4y = function ($completion) {
    var tmp = new $flushCOROUTINE$1(this, $completion);
    tmp.i9_1 = Unit_instance;
    tmp.j9_1 = null;
    return tmp.o9();
  };
  protoOf(ByteChannel).j4y = function () {
    if (this.m4x_1.z4t())
      return Unit_instance;
    // Inline function 'io.ktor.utils.io.locks.synchronized' call
    this.j4x_1;
    var count = this.m4x_1.j().g1();
    this.h4x_1.p4v(this.m4x_1);
    this.i4x_1 = this.i4x_1 + count | 0;
    // Inline function 'io.ktor.utils.io.ByteChannel.resumeSlot' call
    var current = this.k4x_1.kotlinx$atomicfu$value;
    var tmp;
    if (current instanceof Read) {
      tmp = this.k4x_1.atomicfu$compareAndSet(current, Empty_instance);
    } else {
      tmp = false;
    }
    if (tmp) {
      current.c4x();
    }
  };
  protoOf(ByteChannel).g4z = function ($completion) {
    var tmp = new $flushAndCloseCOROUTINE$2(this, $completion);
    tmp.i9_1 = Unit_instance;
    tmp.j9_1 = null;
    return tmp.o9();
  };
  protoOf(ByteChannel).h4z = function (cause) {
    if (!(this.n4x_1.kotlinx$atomicfu$value == null))
      return Unit_instance;
    var closedToken = new CloseToken(cause);
    this.n4x_1.atomicfu$compareAndSet(null, closedToken);
    var actualCause = closedToken.ba();
    closeSlot(this, actualCause);
  };
  protoOf(ByteChannel).toString = function () {
    return 'ByteChannel[' + hashCode(this) + ']';
  };
  function ConcurrentIOException(taskName) {
    IllegalStateException_init_$Init$('Concurrent ' + taskName + ' attempts', this);
    captureStack(this, ConcurrentIOException);
  }
  function ByteReadChannel(content, offset, length) {
    offset = offset === VOID ? 0 : offset;
    length = length === VOID ? content.length : length;
    // Inline function 'kotlin.also' call
    var this_0 = new Buffer();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'io.ktor.utils.io.ByteReadChannel.<anonymous>' call
    this_0.h4v(content, offset, offset + length | 0);
    var source = this_0;
    return ByteReadChannel_0(source);
  }
  function ByteReadChannel_0(source) {
    return new SourceByteReadChannel(source);
  }
  function ByteReadChannel$Companion$Empty$1() {
    this.i4z_1 = null;
    this.j4z_1 = new Buffer();
  }
  protoOf(ByteReadChannel$Companion$Empty$1).z4y = function () {
    return this.i4z_1;
  };
  protoOf(ByteReadChannel$Companion$Empty$1).d4z = function () {
    return true;
  };
  protoOf(ByteReadChannel$Companion$Empty$1).y4y = function () {
    return this.j4z_1;
  };
  protoOf(ByteReadChannel$Companion$Empty$1).e4z = function (min, $completion) {
    return false;
  };
  protoOf(ByteReadChannel$Companion$Empty$1).h4z = function (cause) {
  };
  function Companion_0() {
    Companion_instance_1 = this;
    var tmp = this;
    tmp.k4z_1 = new ByteReadChannel$Companion$Empty$1();
  }
  var Companion_instance_1;
  function Companion_getInstance_0() {
    if (Companion_instance_1 == null)
      new Companion_0();
    return Companion_instance_1;
  }
  function ByteReadChannel_1() {
  }
  function cancel_0(_this__u8e3s4) {
    _this__u8e3s4.h4z(IOException_init_$Create$('Channel was cancelled'));
  }
  function readRemaining(_this__u8e3s4, $completion) {
    var tmp = new $readRemainingCOROUTINE$3(_this__u8e3s4, $completion);
    tmp.i9_1 = Unit_instance;
    tmp.j9_1 = null;
    return tmp.o9();
  }
  function get_availableForRead(_this__u8e3s4) {
    return _this__u8e3s4.y4y().y4t().j().g1();
  }
  function readPacket(_this__u8e3s4, packet, $completion) {
    var tmp = new $readPacketCOROUTINE$4(_this__u8e3s4, packet, $completion);
    tmp.i9_1 = Unit_instance;
    tmp.j9_1 = null;
    return tmp.o9();
  }
  function readAvailable(_this__u8e3s4, buffer, offset, length, $completion) {
    offset = offset === VOID ? 0 : offset;
    length = length === VOID ? buffer.length - offset | 0 : length;
    var tmp = new $readAvailableCOROUTINE$7(_this__u8e3s4, buffer, offset, length, $completion);
    tmp.i9_1 = Unit_instance;
    tmp.j9_1 = null;
    return tmp.o9();
  }
  function toByteArray(_this__u8e3s4, $completion) {
    var tmp = new $toByteArrayCOROUTINE$9(_this__u8e3s4, $completion);
    tmp.i9_1 = Unit_instance;
    tmp.j9_1 = null;
    return tmp.o9();
  }
  function copyTo(_this__u8e3s4, channel, limit, $completion) {
    var tmp = new $copyToCOROUTINE$10(_this__u8e3s4, channel, limit, $completion);
    tmp.i9_1 = Unit_instance;
    tmp.j9_1 = null;
    return tmp.o9();
  }
  function rethrowCloseCauseIfNeeded(_this__u8e3s4) {
    var tmp0_safe_receiver = _this__u8e3s4.z4y();
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      throw tmp0_safe_receiver;
    }
  }
  function readBuffer(_this__u8e3s4, $completion) {
    var tmp = new $readBufferCOROUTINE$12(_this__u8e3s4, $completion);
    tmp.i9_1 = Unit_instance;
    tmp.j9_1 = null;
    return tmp.o9();
  }
  function rethrowCloseCauseIfNeeded_0(_this__u8e3s4) {
    var tmp0_safe_receiver = _this__u8e3s4.z4y();
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      throw tmp0_safe_receiver;
    }
  }
  function rethrowCloseCauseIfNeeded_1(_this__u8e3s4) {
    var tmp0_safe_receiver = _this__u8e3s4.z4y();
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      throw tmp0_safe_receiver;
    }
  }
  function $readRemainingCOROUTINE$3(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.t4z_1 = _this__u8e3s4;
  }
  protoOf($readRemainingCOROUTINE$3).o9 = function () {
    var suspendResult = this.i9_1;
    $sm: do
      try {
        var tmp = this.g9_1;
        switch (tmp) {
          case 0:
            this.h9_1 = 4;
            this.u4z_1 = BytePacketBuilder();
            this.g9_1 = 1;
            continue $sm;
          case 1:
            if (!!this.t4z_1.d4z()) {
              this.g9_1 = 3;
              continue $sm;
            }

            this.u4z_1.p4v(this.t4z_1.y4y());
            this.g9_1 = 2;
            suspendResult = this.t4z_1.f4z(VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.g9_1 = 1;
            continue $sm;
          case 3:
            rethrowCloseCauseIfNeeded(this.t4z_1);
            return this.u4z_1.y4t();
          case 4:
            throw this.j9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.h9_1 === 4) {
          throw e;
        } else {
          this.g9_1 = this.h9_1;
          this.j9_1 = e;
        }
      }
     while (true);
  };
  function $readPacketCOROUTINE$4(_this__u8e3s4, packet, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.d50_1 = _this__u8e3s4;
    this.e50_1 = packet;
  }
  protoOf($readPacketCOROUTINE$4).o9 = function () {
    var suspendResult = this.i9_1;
    $sm: do
      try {
        var tmp = this.g9_1;
        switch (tmp) {
          case 0:
            this.h9_1 = 6;
            this.f50_1 = new Buffer();
            this.g9_1 = 1;
            continue $sm;
          case 1:
            if (!(this.f50_1.j().e1(toLong(this.e50_1)) < 0)) {
              this.g9_1 = 5;
              continue $sm;
            }

            if (this.d50_1.y4y().z4t()) {
              this.g9_1 = 2;
              suspendResult = this.d50_1.f4z(VOID, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.g9_1 = 3;
              continue $sm;
            }

          case 2:
            this.g9_1 = 3;
            continue $sm;
          case 3:
            if (this.d50_1.d4z()) {
              this.g9_1 = 5;
              continue $sm;
            } else {
              this.g9_1 = 4;
              continue $sm;
            }

          case 4:
            if (get_remaining(this.d50_1.y4y()).e1(numberToLong(this.e50_1).v2(this.f50_1.j())) > 0) {
              this.d50_1.y4y().a4v(this.f50_1, numberToLong(this.e50_1).v2(this.f50_1.j()));
            } else {
              this.d50_1.y4y().b4v(this.f50_1);
            }

            this.g9_1 = 1;
            continue $sm;
          case 5:
            if (this.f50_1.j().e1(toLong(this.e50_1)) < 0) {
              throw EOFException_init_$Create$('Not enough data available, required ' + this.e50_1 + ' bytes but only ' + this.f50_1.j().toString() + ' available');
            }

            return this.f50_1;
          case 6:
            throw this.j9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.h9_1 === 6) {
          throw e;
        } else {
          this.g9_1 = this.h9_1;
          this.j9_1 = e;
        }
      }
     while (true);
  };
  function $readAvailableCOROUTINE$7(_this__u8e3s4, buffer, offset, length, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.o50_1 = _this__u8e3s4;
    this.p50_1 = buffer;
    this.q50_1 = offset;
    this.r50_1 = length;
  }
  protoOf($readAvailableCOROUTINE$7).o9 = function () {
    var suspendResult = this.i9_1;
    $sm: do
      try {
        var tmp = this.g9_1;
        switch (tmp) {
          case 0:
            this.h9_1 = 3;
            if (this.o50_1.d4z())
              return -1;
            if (this.o50_1.y4y().z4t()) {
              this.g9_1 = 1;
              suspendResult = this.o50_1.f4z(VOID, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.g9_1 = 2;
              continue $sm;
            }

          case 1:
            this.g9_1 = 2;
            continue $sm;
          case 2:
            if (this.o50_1.d4z())
              return -1;
            return readAvailable_0(this.o50_1.y4y(), this.p50_1, this.q50_1, this.r50_1);
          case 3:
            throw this.j9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.h9_1 === 3) {
          throw e;
        } else {
          this.g9_1 = this.h9_1;
          this.j9_1 = e;
        }
      }
     while (true);
  };
  function $toByteArrayCOROUTINE$9(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.a51_1 = _this__u8e3s4;
  }
  protoOf($toByteArrayCOROUTINE$9).o9 = function () {
    var suspendResult = this.i9_1;
    $sm: do
      try {
        var tmp = this.g9_1;
        switch (tmp) {
          case 0:
            this.h9_1 = 2;
            this.g9_1 = 1;
            suspendResult = readBuffer(this.a51_1, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 1:
            var ARGUMENT = suspendResult;
            return readBytes(ARGUMENT);
          case 2:
            throw this.j9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.h9_1 === 2) {
          throw e;
        } else {
          this.g9_1 = this.h9_1;
          this.j9_1 = e;
        }
      }
     while (true);
  };
  function $copyToCOROUTINE$10(_this__u8e3s4, channel, limit, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.j51_1 = _this__u8e3s4;
    this.k51_1 = channel;
    this.l51_1 = limit;
  }
  protoOf($copyToCOROUTINE$10).o9 = function () {
    var suspendResult = this.i9_1;
    $sm: do
      try {
        var tmp = this.g9_1;
        switch (tmp) {
          case 0:
            this.h9_1 = 12;
            this.m51_1 = this.l51_1;
            this.g9_1 = 1;
            continue $sm;
          case 1:
            this.h9_1 = 8;
            this.h9_1 = 7;
            this.g9_1 = 2;
            continue $sm;
          case 2:
            if (!(!this.j51_1.d4z() && this.m51_1.e1(new Long(0, 0)) > 0)) {
              this.g9_1 = 6;
              continue $sm;
            }

            if (this.j51_1.y4y().z4t()) {
              this.g9_1 = 3;
              suspendResult = this.j51_1.f4z(VOID, this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.g9_1 = 4;
              continue $sm;
            }

          case 3:
            this.g9_1 = 4;
            continue $sm;
          case 4:
            var tmp_0 = this;
            var a = this.m51_1;
            var b = get_remaining(this.j51_1.y4y());
            tmp_0.o51_1 = a.e1(b) <= 0 ? a : b;
            this.j51_1.y4y().a4v(this.k51_1.a4z(), this.o51_1);
            this.m51_1 = this.m51_1.v2(this.o51_1);
            this.g9_1 = 5;
            suspendResult = this.k51_1.x4y(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            this.g9_1 = 2;
            continue $sm;
          case 6:
            this.n51_1 = Unit_instance;
            this.h9_1 = 12;
            this.g9_1 = 10;
            continue $sm;
          case 7:
            this.h9_1 = 8;
            var tmp_1 = this.j9_1;
            if (tmp_1 instanceof Error) {
              this.p51_1 = this.j9_1;
              var tmp_2 = this;
              this.j51_1.h4z(this.p51_1);
              close(this.k51_1, this.p51_1);
              throw this.p51_1;
            } else {
              throw this.j9_1;
            }

          case 8:
            this.h9_1 = 12;
            this.q51_1 = this.j9_1;
            this.g9_1 = 9;
            suspendResult = this.k51_1.x4y(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 9:
            throw this.q51_1;
          case 10:
            this.h9_1 = 12;
            this.g9_1 = 11;
            suspendResult = this.k51_1.x4y(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 11:
            return this.l51_1.v2(this.m51_1);
          case 12:
            throw this.j9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.h9_1 === 12) {
          throw e;
        } else {
          this.g9_1 = this.h9_1;
          this.j9_1 = e;
        }
      }
     while (true);
  };
  function $readBufferCOROUTINE$12(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.z51_1 = _this__u8e3s4;
  }
  protoOf($readBufferCOROUTINE$12).o9 = function () {
    var suspendResult = this.i9_1;
    $sm: do
      try {
        var tmp = this.g9_1;
        switch (tmp) {
          case 0:
            this.h9_1 = 4;
            this.a52_1 = new Buffer();
            this.g9_1 = 1;
            continue $sm;
          case 1:
            if (!!this.z51_1.d4z()) {
              this.g9_1 = 3;
              continue $sm;
            }

            this.a52_1.p4v(this.z51_1.y4y());
            this.g9_1 = 2;
            suspendResult = this.z51_1.f4z(VOID, this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.g9_1 = 1;
            continue $sm;
          case 3:
            var tmp0_safe_receiver = this.z51_1.z4y();
            if (tmp0_safe_receiver == null)
              null;
            else {
              throw tmp0_safe_receiver;
            }

            return this.a52_1;
          case 4:
            throw this.j9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.h9_1 === 4) {
          throw e;
        } else {
          this.g9_1 = this.h9_1;
          this.j9_1 = e;
        }
      }
     while (true);
  };
  function flushIfNeeded(_this__u8e3s4, $completion) {
    var tmp = new $flushIfNeededCOROUTINE$13(_this__u8e3s4, $completion);
    tmp.i9_1 = Unit_instance;
    tmp.j9_1 = null;
    return tmp.o9();
  }
  function $flushIfNeededCOROUTINE$13(_this__u8e3s4, resultContinuation) {
    CoroutineImpl.call(this, resultContinuation);
    this.j52_1 = _this__u8e3s4;
  }
  protoOf($flushIfNeededCOROUTINE$13).o9 = function () {
    var suspendResult = this.i9_1;
    $sm: do
      try {
        var tmp = this.g9_1;
        switch (tmp) {
          case 0:
            this.h9_1 = 3;
            rethrowCloseCauseIfNeeded_0(this.j52_1);
            var tmp_0;
            var tmp_1 = this.j52_1;
            var tmp0_safe_receiver = tmp_1 instanceof ByteChannel ? tmp_1 : null;
            if ((tmp0_safe_receiver == null ? null : tmp0_safe_receiver.g4x_1) === true) {
              tmp_0 = true;
            } else {
              tmp_0 = get_size(this.j52_1.a4z()) >= 1048576;
            }

            if (tmp_0) {
              this.g9_1 = 1;
              suspendResult = this.j52_1.x4y(this);
              if (suspendResult === get_COROUTINE_SUSPENDED()) {
                return suspendResult;
              }
              continue $sm;
            } else {
              this.g9_1 = 2;
              continue $sm;
            }

          case 1:
            this.g9_1 = 2;
            continue $sm;
          case 2:
            return Unit_instance;
          case 3:
            throw this.j9_1;
        }
      } catch ($p) {
        var e = $p;
        if (this.h9_1 === 3) {
          throw e;
        } else {
          this.g9_1 = this.h9_1;
          this.j9_1 = e;
        }
      }
     while (true);
  };
  function get_NO_CALLBACK() {
    _init_properties_ByteWriteChannelOperations_kt__i7slrs();
    return NO_CALLBACK;
  }
  var NO_CALLBACK;
  function WriterJob(channel, job) {
    this.k52_1 = channel;
    this.l52_1 = job;
  }
  protoOf(WriterJob).m4b = function () {
    return this.l52_1;
  };
  function writer(_this__u8e3s4, coroutineContext, autoFlush, block) {
    coroutineContext = coroutineContext === VOID ? EmptyCoroutineContext_getInstance() : coroutineContext;
    autoFlush = autoFlush === VOID ? false : autoFlush;
    _init_properties_ByteWriteChannelOperations_kt__i7slrs();
    return writer_0(_this__u8e3s4, coroutineContext, new ByteChannel(), block);
  }
  function WriterScope(channel, coroutineContext) {
    this.m52_1 = channel;
    this.n52_1 = coroutineContext;
  }
  protoOf(WriterScope).i45 = function () {
    return this.n52_1;
  };
  function writeFully(_this__u8e3s4, value, startIndex, endIndex, $completion) {
    startIndex = startIndex === VOID ? 0 : startIndex;
    endIndex = endIndex === VOID ? value.length : endIndex;
    _this__u8e3s4.a4z().h4v(value, startIndex, endIndex);
    return flushIfNeeded(_this__u8e3s4, $completion);
  }
  function writePacket(_this__u8e3s4, copy, $completion) {
    _this__u8e3s4.a4z().p4v(copy);
    return flushIfNeeded(_this__u8e3s4, $completion);
  }
  function get_isCompleted(_this__u8e3s4) {
    _init_properties_ByteWriteChannelOperations_kt__i7slrs();
    return _this__u8e3s4.m4b().e46();
  }
  function close(_this__u8e3s4, cause) {
    _init_properties_ByteWriteChannelOperations_kt__i7slrs();
    if (cause == null) {
      fireAndForget(ByteWriteChannel$flushAndClose$ref_0(_this__u8e3s4));
    } else {
      _this__u8e3s4.h4z(cause);
    }
  }
  function invokeOnCompletion(_this__u8e3s4, block) {
    _init_properties_ByteWriteChannelOperations_kt__i7slrs();
    var tmp = _this__u8e3s4.m4b();
    tmp.l46(invokeOnCompletion$lambda(block));
  }
  function writer_0(_this__u8e3s4, coroutineContext, channel, block) {
    coroutineContext = coroutineContext === VOID ? EmptyCoroutineContext_getInstance() : coroutineContext;
    _init_properties_ByteWriteChannelOperations_kt__i7slrs();
    // Inline function 'kotlin.apply' call
    var this_0 = launch(_this__u8e3s4, coroutineContext, VOID, writer$slambda_0(block, channel, null));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'io.ktor.utils.io.writer.<anonymous>' call
    this_0.l46(writer$lambda(channel));
    var job = this_0;
    return new WriterJob(channel, job);
  }
  function fireAndForget(_this__u8e3s4) {
    _init_properties_ByteWriteChannelOperations_kt__i7slrs();
    startCoroutineCancellable(_this__u8e3s4, get_NO_CALLBACK());
  }
  function NO_CALLBACK$1() {
    this.o52_1 = EmptyCoroutineContext_getInstance();
  }
  protoOf(NO_CALLBACK$1).m9 = function () {
    return this.o52_1;
  };
  protoOf(NO_CALLBACK$1).n9 = function (result) {
    return Unit_instance;
  };
  protoOf(NO_CALLBACK$1).r9 = function (result) {
    return this.n9(result);
  };
  function ByteWriteChannel$flushAndClose$ref($boundThis) {
    this.p52_1 = $boundThis;
  }
  protoOf(ByteWriteChannel$flushAndClose$ref).q52 = function ($completion) {
    return this.p52_1.g4z($completion);
  };
  protoOf(ByteWriteChannel$flushAndClose$ref).za = function ($completion) {
    return this.q52($completion);
  };
  function ByteWriteChannel$flushAndClose$ref_0($boundThis) {
    var i = new ByteWriteChannel$flushAndClose$ref($boundThis);
    var l = function ($completion) {
      return i.q52($completion);
    };
    l.callableName = 'flushAndClose';
    l.$arity = 0;
    return l;
  }
  function invokeOnCompletion$lambda($block) {
    return function (it) {
      $block();
      return Unit_instance;
    };
  }
  function writer$slambda($block, $channel, resultContinuation) {
    this.z52_1 = $block;
    this.a53_1 = $channel;
    CoroutineImpl.call(this, resultContinuation);
  }
  protoOf(writer$slambda).q53 = function ($this$launch, $completion) {
    var tmp = this.r53($this$launch, $completion);
    tmp.i9_1 = Unit_instance;
    tmp.j9_1 = null;
    return tmp.o9();
  };
  protoOf(writer$slambda).ca = function (p1, $completion) {
    return this.q53((!(p1 == null) ? isInterface(p1, CoroutineScope) : false) ? p1 : THROW_CCE(), $completion);
  };
  protoOf(writer$slambda).o9 = function () {
    var suspendResult = this.i9_1;
    $sm: do
      try {
        var tmp = this.g9_1;
        switch (tmp) {
          case 0:
            this.h9_1 = 14;
            this.c53_1 = Job(get_job(this.b53_1.i45()));
            this.g9_1 = 1;
            continue $sm;
          case 1:
            this.h9_1 = 4;
            this.h9_1 = 3;
            this.g9_1 = 2;
            suspendResult = this.z52_1(new WriterScope(this.a53_1, this.b53_1.i45().bi(this.c53_1)), this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 2:
            this.c53_1.i4c();
            var tmp_0 = this;
            var tmp_1;
            if (get_job(this.b53_1.i45()).f46()) {
              this.a53_1.h4z(get_job(this.b53_1.i45()).i46());
              tmp_1 = Unit_instance;
            }

            tmp_0.d53_1 = tmp_1;
            this.h9_1 = 14;
            this.g9_1 = 9;
            continue $sm;
          case 3:
            this.h9_1 = 4;
            var tmp_2 = this.j9_1;
            if (tmp_2 instanceof Error) {
              this.e53_1 = this.j9_1;
              var tmp_3 = this;
              cancel(this.c53_1, 'Exception thrown while writing to channel', this.e53_1);
              this.a53_1.h4z(this.e53_1);
              tmp_3.d53_1 = Unit_instance;
              this.h9_1 = 14;
              this.g9_1 = 9;
              continue $sm;
            } else {
              throw this.j9_1;
            }

          case 4:
            this.h9_1 = 14;
            this.f53_1 = this.j9_1;
            this.g9_1 = 5;
            suspendResult = this.c53_1.k4c(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 5:
            var tmp_4 = this;
            tmp_4.g53_1 = this.b53_1;
            this.h9_1 = 7;
            var tmp_5 = this;
            tmp_5.i53_1 = Companion_instance;
            var tmp_6 = this;
            tmp_6.j53_1 = this.g53_1;
            this.g9_1 = 6;
            suspendResult = this.a53_1.g4z(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 6:
            var tmp_7 = this;
            tmp_7.k53_1 = Unit_instance;
            this.h53_1 = _Result___init__impl__xyqfz8(this.k53_1);
            this.h9_1 = 14;
            this.g9_1 = 8;
            continue $sm;
          case 7:
            this.h9_1 = 14;
            var tmp_8 = this.j9_1;
            if (tmp_8 instanceof Error) {
              this.l53_1 = this.j9_1;
              var tmp_9 = this;
              var exception = this.l53_1;
              tmp_9.h53_1 = _Result___init__impl__xyqfz8(createFailure(exception));
              this.g9_1 = 8;
              continue $sm;
            } else {
              throw this.j9_1;
            }

          case 8:
            this.h9_1 = 14;
            throw this.f53_1;
          case 9:
            this.h9_1 = 14;
            this.g9_1 = 10;
            suspendResult = this.c53_1.k4c(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 10:
            var tmp_10 = this;
            tmp_10.m53_1 = this.b53_1;
            this.h9_1 = 12;
            var tmp_11 = this;
            tmp_11.o53_1 = Companion_instance;
            var tmp_12 = this;
            tmp_12.p53_1 = this.m53_1;
            this.g9_1 = 11;
            suspendResult = this.a53_1.g4z(this);
            if (suspendResult === get_COROUTINE_SUSPENDED()) {
              return suspendResult;
            }

            continue $sm;
          case 11:
            this.n53_1 = _Result___init__impl__xyqfz8(Unit_instance);
            this.h9_1 = 14;
            this.g9_1 = 13;
            continue $sm;
          case 12:
            this.h9_1 = 14;
            var tmp_13 = this.j9_1;
            if (tmp_13 instanceof Error) {
              var e = this.j9_1;
              var tmp_14 = this;
              tmp_14.n53_1 = _Result___init__impl__xyqfz8(createFailure(e));
              this.g9_1 = 13;
              continue $sm;
            } else {
              throw this.j9_1;
            }

          case 13:
            this.h9_1 = 14;
            return Unit_instance;
          case 14:
            throw this.j9_1;
        }
      } catch ($p) {
        var e_0 = $p;
        if (this.h9_1 === 14) {
          throw e_0;
        } else {
          this.g9_1 = this.h9_1;
          this.j9_1 = e_0;
        }
      }
     while (true);
  };
  protoOf(writer$slambda).r53 = function ($this$launch, completion) {
    var i = new writer$slambda(this.z52_1, this.a53_1, completion);
    i.b53_1 = $this$launch;
    return i;
  };
  function writer$slambda_0($block, $channel, resultContinuation) {
    var i = new writer$slambda($block, $channel, resultContinuation);
    var l = function ($this$launch, $completion) {
      return i.q53($this$launch, $completion);
    };
    l.$arity = 1;
    return l;
  }
  function writer$lambda($channel) {
    return function (it) {
      var tmp;
      if (!(it == null) && !$channel.b4z()) {
        $channel.h4z(it);
        tmp = Unit_instance;
      }
      return Unit_instance;
    };
  }
  var properties_initialized_ByteWriteChannelOperations_kt_acrf6u;
  function _init_properties_ByteWriteChannelOperations_kt__i7slrs() {
    if (!properties_initialized_ByteWriteChannelOperations_kt_acrf6u) {
      properties_initialized_ByteWriteChannelOperations_kt_acrf6u = true;
      NO_CALLBACK = new NO_CALLBACK$1();
    }
  }
  function get_CLOSED() {
    _init_properties_CloseToken_kt__9ucr41();
    return CLOSED;
  }
  var CLOSED;
  function CloseToken(origin) {
    var tmp = this;
    var tmp_0;
    if (origin == null) {
      tmp_0 = null;
    } else {
      if (origin instanceof CancellationException) {
        var tmp_1;
        if (isInterface(origin, CopyableThrowable)) {
          tmp_1 = origin.s4c();
        } else {
          var tmp0_elvis_lhs = origin.message;
          tmp_1 = CancellationException_init_$Create$(tmp0_elvis_lhs == null ? 'Channel was cancelled' : tmp0_elvis_lhs, origin);
        }
        tmp_0 = tmp_1;
      } else {
        var tmp_2;
        if (origin instanceof IOException) {
          tmp_2 = isInterface(origin, CopyableThrowable);
        } else {
          tmp_2 = false;
        }
        if (tmp_2) {
          tmp_0 = origin.s4c();
        } else {
          var tmp1_elvis_lhs = origin.message;
          tmp_0 = IOException_init_$Create$_0(tmp1_elvis_lhs == null ? 'Channel was closed' : tmp1_elvis_lhs, origin);
        }
      }
    }
    tmp.c4z_1 = tmp_0;
  }
  protoOf(CloseToken).ba = function () {
    var tmp;
    if (this.c4z_1 == null) {
      tmp = null;
    } else {
      var tmp_0 = this.c4z_1;
      if (tmp_0 instanceof IOException) {
        var tmp_1;
        var tmp_2 = this.c4z_1;
        if (isInterface(tmp_2, CopyableThrowable)) {
          tmp_1 = this.c4z_1.s4c();
        } else {
          tmp_1 = IOException_init_$Create$_0(this.c4z_1.message, this.c4z_1);
        }
        tmp = tmp_1;
      } else {
        var tmp_3 = this.c4z_1;
        if (!(tmp_3 == null) ? isInterface(tmp_3, CopyableThrowable) : false) {
          var tmp0_elvis_lhs = this.c4z_1.s4c();
          tmp = tmp0_elvis_lhs == null ? CancellationException_init_$Create$(this.c4z_1.message, this.c4z_1) : tmp0_elvis_lhs;
        } else {
          tmp = CancellationException_init_$Create$(this.c4z_1.message, this.c4z_1);
        }
      }
    }
    return tmp;
  };
  var properties_initialized_CloseToken_kt_lgg8zn;
  function _init_properties_CloseToken_kt__9ucr41() {
    if (!properties_initialized_CloseToken_kt_lgg8zn) {
      properties_initialized_CloseToken_kt_lgg8zn = true;
      CLOSED = new CloseToken(null);
    }
  }
  function readText(_this__u8e3s4) {
    return readString(_this__u8e3s4);
  }
  function SourceByteReadChannel(source) {
    this.s53_1 = source;
    this.t53_1 = null;
  }
  protoOf(SourceByteReadChannel).z4y = function () {
    var tmp0_safe_receiver = this.t53_1;
    return tmp0_safe_receiver == null ? null : tmp0_safe_receiver.ba();
  };
  protoOf(SourceByteReadChannel).d4z = function () {
    return this.s53_1.z4t();
  };
  protoOf(SourceByteReadChannel).y4y = function () {
    var tmp0_safe_receiver = this.z4y();
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      throw tmp0_safe_receiver;
    }
    return this.s53_1;
  };
  protoOf(SourceByteReadChannel).e4z = function (min, $completion) {
    var tmp0_safe_receiver = this.z4y();
    if (tmp0_safe_receiver == null)
      null;
    else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      throw tmp0_safe_receiver;
    }
    return get_remaining(this.s53_1).e1(toLong(min)) >= 0;
  };
  protoOf(SourceByteReadChannel).h4z = function (cause) {
    if (!(this.t53_1 == null))
      return Unit_instance;
    this.s53_1.u4v();
    var tmp = this;
    var tmp1_elvis_lhs = cause == null ? null : cause.message;
    tmp.t53_1 = new CloseToken(IOException_init_$Create$_0(tmp1_elvis_lhs == null ? 'Channel was cancelled' : tmp1_elvis_lhs, cause));
  };
  function decode(_this__u8e3s4, input, max) {
    max = max === VOID ? 2147483647 : max;
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.comparisons.minOf' call
    var a = toLong(max);
    var b = input.y4t().j();
    var capacity = (a.e1(b) <= 0 ? a : b).g1();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder_init_$Create$(capacity);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'io.ktor.utils.io.charsets.decode.<anonymous>' call
    decode_0(_this__u8e3s4, input, this_0, max);
    return this_0.toString();
  }
  function encodeToImpl(_this__u8e3s4, destination, input, fromIndex, toIndex) {
    var start = fromIndex;
    if (start >= toIndex)
      return Unit_instance;
    $l$loop: while (true) {
      var rc = encodeImpl(_this__u8e3s4, input, start, toIndex, destination);
      // Inline function 'kotlin.check' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.check' call
      // Inline function 'kotlin.contracts.contract' call
      if (!(rc >= 0)) {
        // Inline function 'kotlin.check.<anonymous>' call
        var message = 'Check failed.';
        throw IllegalStateException_init_$Create$(toString_0(message));
      }
      start = start + rc | 0;
      if (start >= toIndex)
        break $l$loop;
    }
  }
  function encode(_this__u8e3s4, input, fromIndex, toIndex) {
    fromIndex = fromIndex === VOID ? 0 : fromIndex;
    toIndex = toIndex === VOID ? charSequenceLength(input) : toIndex;
    // Inline function 'io.ktor.utils.io.core.buildPacket' call
    var builder = new Buffer();
    // Inline function 'io.ktor.utils.io.charsets.encode.<anonymous>' call
    encodeToImpl(_this__u8e3s4, builder, input, fromIndex, toIndex);
    return builder;
  }
  function canRead(_this__u8e3s4) {
    return !_this__u8e3s4.z4t();
  }
  function readBytes(_this__u8e3s4, count) {
    count = count === VOID ? _this__u8e3s4.j().g1() : count;
    return readByteArray(_this__u8e3s4, count);
  }
  function BytePacketBuilder() {
    return new Buffer();
  }
  function writePacket_0(_this__u8e3s4, packet) {
    _this__u8e3s4.p4v(packet);
  }
  function build(_this__u8e3s4) {
    return _this__u8e3s4.y4t();
  }
  function get_size(_this__u8e3s4) {
    return _this__u8e3s4.y4t().j().g1();
  }
  function writeFully_0(_this__u8e3s4, buffer, offset, length) {
    offset = offset === VOID ? 0 : offset;
    length = length === VOID ? buffer.length - offset | 0 : length;
    _this__u8e3s4.h4v(buffer, offset, offset + length | 0);
  }
  var ByteReadPacketEmpty;
  function get_remaining(_this__u8e3s4) {
    _init_properties_ByteReadPacket_kt__28475y();
    return _this__u8e3s4.y4t().j();
  }
  function discard(_this__u8e3s4, count) {
    count = count === VOID ? new Long(-1, 2147483647) : count;
    _init_properties_ByteReadPacket_kt__28475y();
    _this__u8e3s4.b4u(count);
    // Inline function 'kotlin.comparisons.minOf' call
    var b = get_remaining(_this__u8e3s4);
    var countToDiscard = count.e1(b) <= 0 ? count : b;
    _this__u8e3s4.y4t().v4u(countToDiscard);
    return countToDiscard;
  }
  function takeWhile(_this__u8e3s4, block) {
    _init_properties_ByteReadPacket_kt__28475y();
    while (!_this__u8e3s4.z4t() && block(_this__u8e3s4.y4t())) {
    }
  }
  var properties_initialized_ByteReadPacket_kt_hw4st4;
  function _init_properties_ByteReadPacket_kt__28475y() {
    if (!properties_initialized_ByteReadPacket_kt_hw4st4) {
      properties_initialized_ByteReadPacket_kt_hw4st4 = true;
      ByteReadPacketEmpty = new Buffer();
    }
  }
  function readAvailable_0(_this__u8e3s4, buffer, offset, length) {
    offset = offset === VOID ? 0 : offset;
    length = length === VOID ? buffer.length - offset | 0 : length;
    var result = _this__u8e3s4.w4u(buffer, offset, offset + length | 0);
    return result === -1 ? 0 : result;
  }
  function readText_0(_this__u8e3s4, charset, max) {
    charset = charset === VOID ? Charsets_getInstance().u53_1 : charset;
    max = max === VOID ? 2147483647 : max;
    if (charset.equals(Charsets_getInstance().u53_1)) {
      if (max === 2147483647)
        return readString(_this__u8e3s4);
      // Inline function 'kotlin.math.min' call
      var a = _this__u8e3s4.y4t().j();
      var b = toLong(max);
      var count = a.e1(b) <= 0 ? a : b;
      return readString_0(_this__u8e3s4, count);
    }
    return decode(charset.x53(), _this__u8e3s4, max);
  }
  function toByteArray_0(_this__u8e3s4, charset) {
    charset = charset === VOID ? Charsets_getInstance().u53_1 : charset;
    if (charset.equals(Charsets_getInstance().u53_1))
      return encodeToByteArray(_this__u8e3s4, VOID, VOID, true);
    return encodeToByteArray_0(charset.y53(), _this__u8e3s4, 0, _this__u8e3s4.length);
  }
  function writeText(_this__u8e3s4, text, fromIndex, toIndex, charset) {
    fromIndex = fromIndex === VOID ? 0 : fromIndex;
    toIndex = toIndex === VOID ? charSequenceLength(text) : toIndex;
    charset = charset === VOID ? Charsets_getInstance().u53_1 : charset;
    if (charset === Charsets_getInstance().u53_1) {
      return writeString(_this__u8e3s4, toString_0(text), fromIndex, toIndex);
    }
    encodeToImpl(charset.y53(), _this__u8e3s4, text, fromIndex, toIndex);
  }
  function get_ByteArrayPool() {
    _init_properties_ByteArrayPool_kt__kfi3uj();
    return ByteArrayPool;
  }
  var ByteArrayPool;
  function ByteArrayPool$1() {
    DefaultPool.call(this, 128);
  }
  protoOf(ByteArrayPool$1).c54 = function () {
    return new Int8Array(4096);
  };
  var properties_initialized_ByteArrayPool_kt_td6pfh;
  function _init_properties_ByteArrayPool_kt__kfi3uj() {
    if (!properties_initialized_ByteArrayPool_kt_td6pfh) {
      properties_initialized_ByteArrayPool_kt_td6pfh = true;
      ByteArrayPool = new ByteArrayPool$1();
    }
  }
  function Companion_1() {
  }
  protoOf(Companion_1).l54 = function (name) {
    switch (name) {
      case 'UTF-8':
      case 'utf-8':
      case 'UTF8':
      case 'utf8':
        return Charsets_getInstance().u53_1;
    }
    var tmp;
    var tmp_0;
    var tmp_1;
    switch (name) {
      case 'ISO-8859-1':
      case 'iso-8859-1':
        tmp_1 = true;
        break;
      default:
        // Inline function 'kotlin.let' call

        // Inline function 'kotlin.contracts.contract' call

        // Inline function 'io.ktor.utils.io.charsets.Companion.forName.<anonymous>' call

        var it = replace(name, _Char___init__impl__6a9atx(95), _Char___init__impl__6a9atx(45));
        var tmp_2;
        if (it === 'iso-8859-1') {
          tmp_2 = true;
        } else {
          // Inline function 'kotlin.text.lowercase' call
          // Inline function 'kotlin.js.asDynamic' call
          tmp_2 = it.toLowerCase() === 'iso-8859-1';
        }

        tmp_1 = tmp_2;
        break;
    }
    if (tmp_1) {
      tmp_0 = true;
    } else {
      tmp_0 = name === 'latin1';
    }
    if (tmp_0) {
      tmp = true;
    } else {
      tmp = name === 'Latin1';
    }
    if (tmp) {
      return Charsets_getInstance().v53_1;
    }
    throw IllegalArgumentException_init_$Create$('Charset ' + name + ' is not supported');
  };
  protoOf(Companion_1).m54 = function (charset) {
    var tmp;
    switch (charset) {
      case 'UTF-8':
      case 'utf-8':
      case 'UTF8':
      case 'utf8':
        tmp = true;
        break;
      default:
        var tmp_0;
        var tmp_1;
        switch (charset) {
          case 'ISO-8859-1':
          case 'iso-8859-1':
            tmp_1 = true;
            break;
          default:
            // Inline function 'kotlin.let' call

            // Inline function 'kotlin.contracts.contract' call

            // Inline function 'io.ktor.utils.io.charsets.Companion.isSupported.<anonymous>' call

            var it = replace(charset, _Char___init__impl__6a9atx(95), _Char___init__impl__6a9atx(45));
            var tmp_2;
            if (it === 'iso-8859-1') {
              tmp_2 = true;
            } else {
              // Inline function 'kotlin.text.lowercase' call
              // Inline function 'kotlin.js.asDynamic' call
              tmp_2 = it.toLowerCase() === 'iso-8859-1';
            }

            tmp_1 = tmp_2;
            break;
        }

        if (tmp_1) {
          tmp_0 = true;
        } else {
          tmp_0 = charset === 'latin1';
        }

        if (tmp_0) {
          tmp = true;
        } else {
          tmp = false;
        }

        break;
    }
    return tmp;
  };
  var Companion_instance_2;
  function Companion_getInstance_1() {
    return Companion_instance_2;
  }
  function Charset(_name) {
    this.w53_1 = _name;
  }
  protoOf(Charset).equals = function (other) {
    if (this === other)
      return true;
    if (other == null || !(this.constructor == other.constructor))
      return false;
    if (!(other instanceof Charset))
      THROW_CCE();
    return this.w53_1 === other.w53_1;
  };
  protoOf(Charset).hashCode = function () {
    return getStringHashCode(this.w53_1);
  };
  protoOf(Charset).toString = function () {
    return this.w53_1;
  };
  function get_name(_this__u8e3s4) {
    return _this__u8e3s4.w53_1;
  }
  function Charsets() {
    Charsets_instance = this;
    this.u53_1 = new CharsetImpl('UTF-8');
    this.v53_1 = new CharsetImpl('ISO-8859-1');
  }
  var Charsets_instance;
  function Charsets_getInstance() {
    if (Charsets_instance == null)
      new Charsets();
    return Charsets_instance;
  }
  function MalformedInputException(message) {
    IOException_init_$Init$(message, this);
    captureStack(this, MalformedInputException);
  }
  function CharsetDecoder(_charset) {
    this.n54_1 = _charset;
  }
  function CharsetEncoder(_charset) {
    this.o54_1 = _charset;
  }
  function CharsetImpl(name) {
    Charset.call(this, name);
  }
  protoOf(CharsetImpl).y53 = function () {
    return new CharsetEncoderImpl(this);
  };
  protoOf(CharsetImpl).x53 = function () {
    return new CharsetDecoderImpl(this);
  };
  function CharsetEncoderImpl(charset) {
    CharsetEncoder.call(this, charset);
    this.r54_1 = charset;
  }
  protoOf(CharsetEncoderImpl).toString = function () {
    return 'CharsetEncoderImpl(charset=' + this.r54_1.toString() + ')';
  };
  protoOf(CharsetEncoderImpl).hashCode = function () {
    return this.r54_1.hashCode();
  };
  protoOf(CharsetEncoderImpl).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CharsetEncoderImpl))
      return false;
    var tmp0_other_with_cast = other instanceof CharsetEncoderImpl ? other : THROW_CCE();
    if (!this.r54_1.equals(tmp0_other_with_cast.r54_1))
      return false;
    return true;
  };
  function CharsetDecoderImpl(charset) {
    CharsetDecoder.call(this, charset);
    this.t54_1 = charset;
  }
  protoOf(CharsetDecoderImpl).toString = function () {
    return 'CharsetDecoderImpl(charset=' + this.t54_1.toString() + ')';
  };
  protoOf(CharsetDecoderImpl).hashCode = function () {
    return this.t54_1.hashCode();
  };
  protoOf(CharsetDecoderImpl).equals = function (other) {
    if (this === other)
      return true;
    if (!(other instanceof CharsetDecoderImpl))
      return false;
    var tmp0_other_with_cast = other instanceof CharsetDecoderImpl ? other : THROW_CCE();
    if (!this.t54_1.equals(tmp0_other_with_cast.t54_1))
      return false;
    return true;
  };
  function encodeToByteArray_0(_this__u8e3s4, input, fromIndex, toIndex) {
    fromIndex = fromIndex === VOID ? 0 : fromIndex;
    toIndex = toIndex === VOID ? charSequenceLength(input) : toIndex;
    return encodeToByteArrayImpl(_this__u8e3s4, input, fromIndex, toIndex);
  }
  function decode_0(_this__u8e3s4, input, dst, max) {
    var decoder = Decoder(get_name(get_charset(_this__u8e3s4)), true);
    // Inline function 'kotlin.comparisons.minOf' call
    var a = input.y4t().j();
    var b = toLong(max);
    var count = a.e1(b) <= 0 ? a : b;
    var tmp = readByteArray(input, count.g1());
    var array = tmp instanceof Int8Array ? tmp : THROW_CCE();
    var tmp_0;
    try {
      tmp_0 = decoder.u54(array);
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var cause = $p;
        var tmp0_elvis_lhs = cause.message;
        throw new MalformedInputException('Failed to decode bytes: ' + (tmp0_elvis_lhs == null ? 'no cause provided' : tmp0_elvis_lhs));
      } else {
        throw $p;
      }
    }
    var result = tmp_0;
    dst.f(result);
    return result.length;
  }
  function encodeToByteArrayImpl(_this__u8e3s4, input, fromIndex, toIndex) {
    fromIndex = fromIndex === VOID ? 0 : fromIndex;
    toIndex = toIndex === VOID ? charSequenceLength(input) : toIndex;
    var start = fromIndex;
    if (start >= toIndex)
      return new Int8Array(0);
    var dst = new Buffer();
    var rc = encodeImpl(_this__u8e3s4, input, start, toIndex, dst);
    start = start + rc | 0;
    if (start === toIndex) {
      return readByteArray_0(dst);
    }
    encodeToImpl(_this__u8e3s4, dst, input, start, toIndex);
    return readByteArray_0(dst);
  }
  function get_charset(_this__u8e3s4) {
    return _this__u8e3s4.n54_1;
  }
  function encodeImpl(_this__u8e3s4, input, fromIndex, toIndex, dst) {
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(fromIndex <= toIndex)) {
      // Inline function 'kotlin.require.<anonymous>' call
      var message = 'Failed requirement.';
      throw IllegalArgumentException_init_$Create$(toString_0(message));
    }
    if (get_charset_0(_this__u8e3s4).equals(Charsets_getInstance().v53_1)) {
      return encodeISO88591(input, fromIndex, toIndex, dst);
    }
    // Inline function 'kotlin.require' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(get_charset_0(_this__u8e3s4) === Charsets_getInstance().u53_1)) {
      // Inline function 'io.ktor.utils.io.charsets.encodeImpl.<anonymous>' call
      var message_0 = 'Only UTF-8 encoding is supported in JS';
      throw IllegalArgumentException_init_$Create$(toString_0(message_0));
    }
    var encoder = new TextEncoder();
    // Inline function 'kotlin.text.substring' call
    var tmp$ret$2 = toString_0(charSequenceSubSequence(input, fromIndex, toIndex));
    var result = encoder.encode(tmp$ret$2);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    dst.k4v(result);
    return result.length;
  }
  function get_charset_0(_this__u8e3s4) {
    return _this__u8e3s4.o54_1;
  }
  function forName(_this__u8e3s4, name) {
    return Companion_instance_2.l54(name);
  }
  function isSupported(_this__u8e3s4, name) {
    return Companion_instance_2.m54(name);
  }
  function Decoder(encoding, fatal) {
    fatal = fatal === VOID ? true : fatal;
    var tmp;
    try {
      tmp = toKtor(new TextDecoder(encoding, textDecoderOptions(fatal)));
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var cause = $p;
        tmp_0 = new TextDecoderFallback(encoding, fatal);
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  function toKtor(_this__u8e3s4) {
    return new toKtor$1(_this__u8e3s4);
  }
  function textDecoderOptions(fatal) {
    fatal = fatal === VOID ? false : fatal;
    // Inline function 'kotlin.apply' call
    var this_0 = new Object();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'io.ktor.utils.io.charsets.textDecoderOptions.<anonymous>' call
    // Inline function 'kotlin.with' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.contracts.contract' call
    this_0.fatal = fatal;
    return this_0;
  }
  function toKtor$1($this_toKtor) {
    this.v54_1 = $this_toKtor;
  }
  protoOf(toKtor$1).u54 = function (buffer) {
    return this.v54_1.decode(buffer);
  };
  function get_ENCODING_ALIASES() {
    _init_properties_TextDecoderFallback_js_kt__an7r6m();
    return ENCODING_ALIASES;
  }
  var ENCODING_ALIASES;
  function get_REPLACEMENT() {
    _init_properties_TextDecoderFallback_js_kt__an7r6m();
    return REPLACEMENT;
  }
  var REPLACEMENT;
  function TextDecoderFallback(encoding, fatal) {
    this.w54_1 = fatal;
    // Inline function 'kotlin.text.lowercase' call
    // Inline function 'kotlin.text.trim' call
    // Inline function 'kotlin.js.asDynamic' call
    var requestedEncoding = toString_0(trim(isCharSequence(encoding) ? encoding : THROW_CCE())).toLowerCase();
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!get_ENCODING_ALIASES().r(requestedEncoding)) {
      // Inline function 'io.ktor.utils.io.charsets.TextDecoderFallback.<anonymous>' call
      var message = encoding + ' is not supported.';
      throw IllegalStateException_init_$Create$(toString_0(message));
    }
  }
  protoOf(TextDecoderFallback).u54 = function (buffer) {
    // Inline function 'io.ktor.utils.io.core.buildPacket' call
    var builder = new Buffer();
    // Inline function 'io.ktor.utils.io.charsets.TextDecoderFallback.decode.<anonymous>' call
    var bytes = buffer instanceof Int8Array ? buffer : THROW_CCE();
    var inductionVariable = 0;
    var last = bytes.length;
    if (inductionVariable < last)
      $l$loop: do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'org.khronos.webgl.get' call
        // Inline function 'kotlin.js.asDynamic' call
        var byte = bytes[index];
        var point = toCodePoint(byte);
        if (point < 0) {
          // Inline function 'kotlin.check' call
          // Inline function 'kotlin.contracts.contract' call
          if (!!this.w54_1) {
            // Inline function 'io.ktor.utils.io.charsets.TextDecoderFallback.decode.<anonymous>.<anonymous>' call
            var message = 'Invalid character: ' + point;
            throw IllegalStateException_init_$Create$(toString_0(message));
          }
          writeFully_0(builder, get_REPLACEMENT());
          continue $l$loop;
        }
        if (point > 255) {
          builder.q4v(toByte(point >> 8));
        }
        builder.q4v(toByte(point & 255));
      }
       while (inductionVariable < last);
    return decodeToString(readByteArray_0(builder));
  };
  function toCodePoint(_this__u8e3s4) {
    _init_properties_TextDecoderFallback_js_kt__an7r6m();
    var value = _this__u8e3s4 & 255;
    if (isASCII(value)) {
      return value;
    }
    return get_WIN1252_TABLE()[value - 128 | 0];
  }
  function isASCII(_this__u8e3s4) {
    _init_properties_TextDecoderFallback_js_kt__an7r6m();
    return 0 <= _this__u8e3s4 ? _this__u8e3s4 <= 127 : false;
  }
  var properties_initialized_TextDecoderFallback_js_kt_6rekzk;
  function _init_properties_TextDecoderFallback_js_kt__an7r6m() {
    if (!properties_initialized_TextDecoderFallback_js_kt_6rekzk) {
      properties_initialized_TextDecoderFallback_js_kt_6rekzk = true;
      ENCODING_ALIASES = setOf(['ansi_x3.4-1968', 'ascii', 'cp1252', 'cp819', 'csisolatin1', 'ibm819', 'iso-8859-1', 'iso-ir-100', 'iso8859-1', 'iso88591', 'iso_8859-1', 'iso_8859-1:1987', 'l1', 'latin1', 'us-ascii', 'windows-1252', 'x-cp1252']);
      // Inline function 'kotlin.byteArrayOf' call
      REPLACEMENT = new Int8Array([-17, -65, -67]);
    }
  }
  function encodeISO88591(input, fromIndex, toIndex, dst) {
    if (fromIndex >= toIndex)
      return 0;
    var inductionVariable = fromIndex;
    if (inductionVariable < toIndex)
      do {
        var index = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'kotlin.code' call
        var this_0 = charSequenceGet(input, index);
        var character = Char__toInt_impl_vasixd(this_0);
        if (character > 255) {
          failedToMapError(character);
        }
        dst.q4v(toByte(character));
      }
       while (inductionVariable < toIndex);
    return toIndex - fromIndex | 0;
  }
  function failedToMapError(ch) {
    throw new MalformedInputException('The character with unicode point ' + ch + " couldn't be mapped to ISO-8859-1 character");
  }
  function get_WIN1252_TABLE() {
    _init_properties_Win1252Table_kt__tl0v64();
    return WIN1252_TABLE;
  }
  var WIN1252_TABLE;
  var properties_initialized_Win1252Table_kt_pkmjoq;
  function _init_properties_Win1252Table_kt__tl0v64() {
    if (!properties_initialized_Win1252Table_kt_pkmjoq) {
      properties_initialized_Win1252Table_kt_pkmjoq = true;
      // Inline function 'kotlin.intArrayOf' call
      WIN1252_TABLE = new Int32Array([8364, -1, 8218, 402, 8222, 8230, 8224, 8225, 710, 8240, 352, 8249, 338, -1, 381, -1, -1, 8216, 8217, 8220, 8221, 8226, 8211, 8212, 732, 8482, 353, 8250, 339, -1, 382, 376, 160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 174, 175, 176, 177, 178, 179, 180, 181, 182, 183, 184, 185, 186, 187, 188, 189, 190, 191, 192, 193, 194, 195, 196, 197, 198, 199, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 220, 221, 222, 223, 224, 225, 226, 227, 228, 229, 230, 231, 232, 233, 234, 235, 236, 237, 238, 239, 240, 241, 242, 243, 244, 245, 246, 247, 248, 249, 250, 251, 252, 253, 254, 255]);
    }
  }
  function DefaultPool(capacity) {
    this.d54_1 = capacity;
    var tmp = this;
    // Inline function 'kotlin.arrayOfNulls' call
    var size = this.d54_1;
    tmp.e54_1 = fillArrayVal(Array(size), null);
    this.f54_1 = 0;
  }
  protoOf(DefaultPool).g54 = function (instance) {
  };
  protoOf(DefaultPool).h54 = function (instance) {
    return instance;
  };
  protoOf(DefaultPool).i54 = function (instance) {
  };
  protoOf(DefaultPool).j54 = function () {
    if (this.f54_1 === 0)
      return this.c54();
    this.f54_1 = this.f54_1 - 1 | 0;
    var idx = this.f54_1;
    var tmp = this.e54_1[idx];
    var instance = !(tmp == null) ? tmp : THROW_CCE();
    this.e54_1[idx] = null;
    return this.h54(instance);
  };
  protoOf(DefaultPool).k54 = function (instance) {
    this.i54(instance);
    if (this.f54_1 === this.d54_1) {
      this.g54(instance);
    } else {
      var _unary__edvuaz = this.f54_1;
      this.f54_1 = _unary__edvuaz + 1 | 0;
      this.e54_1[_unary__edvuaz] = instance;
    }
  };
  //region block: post-declaration
  protoOf(Read).c4x = resume;
  protoOf(Read).d4x = resume_0;
  protoOf(Write).c4x = resume;
  protoOf(Write).d4x = resume_0;
  protoOf(ByteChannel).f4z = awaitContent$default;
  protoOf(ByteReadChannel$Companion$Empty$1).f4z = awaitContent$default;
  protoOf(SourceByteReadChannel).f4z = awaitContent$default;
  //endregion
  //region block: init
  Empty_instance = new Empty();
  Companion_instance_2 = new Companion_1();
  //endregion
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = copyTo;
  _.$_$.b = readAvailable;
  _.$_$.c = readPacket;
  _.$_$.d = readRemaining;
  _.$_$.e = toByteArray;
  _.$_$.f = writeFully;
  _.$_$.g = writePacket;
  _.$_$.h = Charsets_getInstance;
  _.$_$.i = Companion_getInstance_0;
  _.$_$.j = MalformedInputException;
  _.$_$.k = decode;
  _.$_$.l = encode;
  _.$_$.m = forName;
  _.$_$.n = isSupported;
  _.$_$.o = get_name;
  _.$_$.p = BytePacketBuilder;
  _.$_$.q = build;
  _.$_$.r = canRead;
  _.$_$.s = discard;
  _.$_$.t = readText_0;
  _.$_$.u = takeWhile;
  _.$_$.v = toByteArray_0;
  _.$_$.w = writeFully_0;
  _.$_$.x = writePacket_0;
  _.$_$.y = writeText;
  _.$_$.z = get_ByteArrayPool;
  _.$_$.a1 = ByteReadChannel;
  _.$_$.b1 = ByteReadChannel_1;
  _.$_$.c1 = WriterScope;
  _.$_$.d1 = get_availableForRead;
  _.$_$.e1 = cancel_0;
  _.$_$.f1 = close;
  _.$_$.g1 = invokeOnCompletion;
  _.$_$.h1 = get_isCompleted;
  _.$_$.i1 = readText;
  _.$_$.j1 = writer;
  //endregion
  return _;
}));
